<script setup lang="ts">
import {inject, ref} from "vue";
import {useRoute} from "vue-router";
import Str from "@/Utils/Str";
import {getStimuli as getStimuliFromApi} from "@/Services/Admin/admin-stimuli";
import {Column, DataTable, Tag} from "@/Components/Library";
import {PageHeading, TableRecordActions} from "@/Components/Global";
import type dayjs from "dayjs";
import {AdminIndex} from "@/Types/index.d";
import {Icon} from "@iconify/vue";

type StimulusLocal = any;

const currentRoute = useRoute();
const $date = inject("date") as typeof dayjs;
const stimuli = ref<AdminIndex<StimulusLocal>>();

const getStimuli = async () =>
    getStimuliFromApi({
        ...currentRoute.query,
    }).then((data) => (stimuli.value = data));
getStimuli();
</script>
<template>
    <div>
        <div class="m-container">
            <PageHeading title="Stimuli">
                <!--            <template #buttons>-->
                <!--                <RouterLink class="ml-auto" :to="{name: 'admin.stimuli.create'}">-->
                <!--                    <Button-->
                <!--                        rounded-->
                <!--                        class="bg-askr-green text-sm text-white hover:brightness-110"-->
                <!--                        :icon="{-->
                <!--                            icon: 'ic:round-plus',-->
                <!--                            width: '24',-->
                <!--                        }"-->
                <!--                    >-->
                <!--                        Create Stimulus-->
                <!--                    </Button>-->
                <!--                </RouterLink>-->
                <!--            </template>-->
            </PageHeading>
        </div>
        <DataTable :data="stimuli" dataKey="id" :loading="false" @filter="getStimuli" defaultSort="-created_at">
            <Column expander style="width: 0" />
            <Column field="id" header="ID">
                <template #body="{data}">
                    <RouterLink
                        :to="{
                            name: 'admin.stimuli.show',
                            params: {stimulus: data.id},
                        }"
                        class="hover:underline"
                    >
                        {{ data.id }}
                    </RouterLink>
                </template>
            </Column>
            <Column field="title" header="Title" :sortable="true">
                <template #body="{data}">
                    <RouterLink
                        :to="{
                            name: 'admin.stimuli.show',
                            params: {stimulus: data.id},
                        }"
                        class="hover:underline"
                    >
                        {{ Str.of(data.title).truncate(20) }}
                    </RouterLink>
                </template>
            </Column>
            <Column field="data" header="Data">
                <template #body="{data}">
                    <RouterLink
                        :to="{
                            name: 'admin.stimuli.show',
                            params: {stimulus: data.id},
                        }"
                        class="hover:underline"
                    >
                        {{ data.data ? Str.of(data.data).truncate(20) : "-" }}
                    </RouterLink>
                </template>
            </Column>
            <Column field="type" header="Type" :sortable="true">
                <template #body="{data}">
                    <Tag>
                        <Icon :icon="data.type.icon" class="mr-2 h-4 w-4" />
                        <span class="text-xs">{{ data.type.name }}</span>
                    </Tag>
                </template>
            </Column>
            <Column field="created_at" header="Created At" :sortable="true">
                <template #body="{data}">
                    {{ $date(data.created_at).format("DD/MM/YYYY HH:mm") }}
                </template>
            </Column>
            <Column field="deleted_at" header="Deleted At" :sortable="true">
                <template #body="{data}">
                    {{ data.deleted_at ? $date(data.deleted_at).format("DD/MM/YYYY HH:mm") : null }}
                </template>
            </Column>
            <Column header="Actions" style="width: 0">
                <template #body="{data}">
                    <TableRecordActions
                        name="Stimulus"
                        :deleted="!!data.deleted_at"
                        :routes="{
                            show: {
                                name: 'admin.stimuli.show',
                                params: {stimulus: data.id},
                            },
                            // edit: {
                            //     name: 'admin.stimuli.edit',
                            //     params: {id: data.id},
                            // },
                            delete: route('admin.stimuli.destroy', data.id),
                            restore: route('admin.stimuli.restore', data.id),
                        }"
                        @deleted="getStimuli"
                    />
                </template>
            </Column>
            <template #expansion="{data}">
                <pre>{{ data }}</pre>
            </template>
        </DataTable>
    </div>
</template>
<style scoped></style>
